module.exports = __webpack_public_path__ + "static/media/playspace_section2.6a7cfe1e.png";